var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"masked-icon-link",attrs:{"href":_vm.href,"target":"_blank"}},[_c('div',{staticClass:"masked-icon",class:{ inverted: _vm.inverted },style:(_vm.style)},[_c('img',{staticClass:"masked-image-spacer",attrs:{"src":_vm.maskIcon,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }